<template>
  <div>
    <!--<div class="w-full grid grid-cols-8 gap-2 p-4 lg:p-2 justify-center items-center" :class="index % 2 == 0 ? 'bg-woodsmoke-800/30' : ''">
      
      <div class="lg:col-span-2 col-span-full flex justify-between items-center lg:mb-0 mb-4 pl-2">
          <div class="flex justify-start items-center space-x-2">
            <div class="w-10 h-10 bg-white/10 rounded-xl overflow-hidden border border-white/50">
              <img :src="pool?.project?.project_logo" />
            </div>
            <strong class="text-lg row-span-2">{{ pool?.project?.project_name }}</strong>
          </div>

          <!~~ <div class="flex lg:hidden">
            <button @click="showDetails = !showDetails" class="btn btn-sm w-full hover:text-turquoise-500 hover:bg-black" :class="showDetails ? 'bg-turquoise-500 text-woodsmoke-900' : 'text-turquoise-500 bg-woodsmoke-800'">{{ showDetails ? "Hide" : "Details" }}</button>
          </div> ~~>
        </div>

     <!~~ <div class="col-span-full xl:col-span-7 grid grid-cols-5 gap-2">
        

        <!~~ <div class="mb-2">
                        <strong class="text-lg">Project Name</strong>
                    </div> ~~>
        
      </div>~~>

      <div class="w-full grid grid-cols-3 justify-center items-center lg:col-span-5 col-span-7">
          <div class="text-xs text-woodsmoke-300">Initial Contribution</div>
          <div class="text-xs text-woodsmoke-300">Total Refund</div>
          <div class="text-xs text-turquoise-300">Effective Contribution</div>

          <div class="text-woodsmoke-100">{{ pool?.total_initial_contribution.toFixed(2) }} {{ pool?.pools[0]?.currency_symbol ? pool?.pools[0]?.currency_symbol : "USDC" }}</div>
          <div v-if="pool?.project?.project_status == 'COMPLETED'" class="text-woodsmoke-100">{{ pool?.total_refund.toFixed(2) }} {{ pool?.pools[0]?.currency_symbol ? pool?.pools[0]?.currency_symbol : "USDC" }}</div>
          <div v-if="pool?.project?.project_status != 'COMPLETED'" class="text-woodsmoke-100">TBC</div>
          <div v-if="pool?.project?.project_status == 'COMPLETED'" class="text-turquoise-500">{{ pool?.total_effective_contribution.toFixed(2) }} {{ pool?.pools[0]?.currency_symbol ? pool?.pools[0]?.currency_symbol : "USDC" }}</div>
          <div v-if="pool?.project?.project_status != 'COMPLETED'" class="text-woodsmoke-100">TBC</div>
        </div>

      <div class="sm:flex hidden w-full justify-center items-center pr-2">
        <button @click="showDetails = !showDetails" class="btn w-full hover:text-turquoise-500 hover:bg-black" :class="showDetails ? 'bg-turquoise-500 text-woodsmoke-900' : 'text-turquoise-500 bg-woodsmoke-800'">{{ showDetails ? "Hide" : "Details" }}</button>
      </div>
    </div>-->

    <div class="xl:hidden w-full p-4 border-b border-b-white/10" :class="index % 2 == 0 ? 'bg-woodsmoke-800/30' : ''">
      <div class="w-full flex justify-between items-center mb-2">
        <div class="flex justify-start items-center space-x-2">
         
          
          <UTooltip text="Go to Project" >
              <NuxtLink :to="`/app/project/${pool.project.project_id}`" class="w-10 h-10 bg-white/10 rounded-xl overflow-hidden border border-white/50 hover:scale-110 duration-75">
              <img :src="pool?.project?.project_logo" />
            </NuxtLink>
          </UTooltip>

          <strong class="text-lg row-span-2">{{ pool?.project?.project_name }}</strong>
        </div>

        <button @click="showDetails = !showDetails" class="btn btn-sm hover:text-turquoise-500 hover:bg-black" :class="showDetails ? 'bg-turquoise-500 text-woodsmoke-900' : 'text-turquoise-500 bg-woodsmoke-800'">{{ showDetails ? "Hide" : "Details" }}</button>

      </div>

      <div class="text-sm flex justify-start items-center space-x-2">
        <p class="text-white">Initial Contribution</p>
        <div class="text-woodsmoke-100">{{ pool?.total_initial_contribution.toFixed(2) }} {{ pool?.pools[0]?.currency_symbol ? pool?.pools[0]?.currency_symbol : "USDC" }}</div>
      </div>
      <div class="text-sm flex justify-start items-center space-x-2">
        <p class="text-white">Total Refund</p>
        <div v-if="!pool?.project?.is_concluded" class="text-woodsmoke-100">TBC</div>
        <div v-else class="text-woodsmoke-100">{{ pool?.total_refund.toFixed(2) }} {{ pool?.pools[0]?.currency_symbol ? pool?.pools[0]?.currency_symbol : "USDC" }}</div>
      </div>
      <div class="text-sm flex justify-start items-center space-x-2">
        <p class="text-white">Effective Contribution</p>
          <div v-if="!pool?.project?.is_concluded" class="text-woodsmoke-100">TBC</div>
          <div v-else class="text-turquoise-500">{{ pool?.total_effective_contribution.toFixed(2) }} {{ pool?.pools[0]?.currency_symbol ? pool?.pools[0]?.currency_symbol : "USDC" }}</div>
      </div>
    </div>

    <div class="xl:block hidden w-full p-4 border-b border-b-white/10" :class="index % 2 == 0 ? 'bg-woodsmoke-800/30' : ''">
      <div class="w-full flex justify-between items-center mb-2">
        <div class="flex justify-start items-center space-x-2">

          <UTooltip text="Go to Project" >
              <NuxtLink :to="`/app/project/${pool.project.project_id}`" class="w-10 h-10 bg-white/10 rounded-xl overflow-hidden border border-white/50 hover:scale-110 duration-75">
              <img :src="pool?.project?.project_logo" />
            </NuxtLink>
          </UTooltip>

          <strong class="text-lg row-span-2">{{ pool?.project?.project_name }}</strong>
        </div>

      </div>
      
      <div class="grid grid-cols-4">

        <div class="">
        <p class="text-white text-sm">Initial Contribution</p>
        <div class="text-woodsmoke-100">{{ pool?.total_initial_contribution.toFixed(2) }} {{ pool?.pools[0]?.currency_symbol ? pool?.pools[0]?.currency_symbol : "USDC" }}</div>
      </div>
      <div class="">
        <p class="text-white text-sm">Total Refund</p>
        <div v-if="!pool?.project?.is_concluded" class="text-woodsmoke-100">TBC</div>
        <div v-else class="text-woodsmoke-100">{{ pool?.total_refund.toFixed(2) }} {{ pool?.pools[0]?.currency_symbol ? pool?.pools[0]?.currency_symbol : "USDC" }}</div>
      </div>
      <div class="">
        <p class="text-white text-sm">Effective Contribution</p>
        <div v-if="!pool?.project?.is_concluded" class="text-woodsmoke-100">TBC</div>
        <div v-else class="text-turquoise-500">{{ pool?.total_effective_contribution.toFixed(2) }} {{ pool?.pools[0]?.currency_symbol ? pool?.pools[0]?.currency_symbol : "USDC" }}</div>
      </div>


        <div class="w-full flex justify-end items-center">
          <button @click="showDetails = !showDetails" class="btn btn-sm hover:text-turquoise-500 hover:bg-black" :class="showDetails ? 'bg-turquoise-500 text-woodsmoke-900' : 'text-turquoise-500 bg-woodsmoke-800'">{{ showDetails ? "Hide" : "Details" }}</button>
        </div>
      </div>

      
    </div>

    <div v-if="showDetails" class="w-full pl-6">
      <ul>
        <li v-for="p in pool?.pools" :key="p" class="">
          <article v-if="p?.contrib_activity?.length > 0" class="w-full flex justify-start items-center pt-4">
            <div class="flex justify-start items-center px-2 p-1 bg-woodsmoke-700 rounded-md text-sm">
              <VDropdown>
                <button class="-mt-0.5 flex-shrink-0 btn btn-circle w-4 h-4 min-h-0 min-w-0 p-0 m-0 btn-ghost bg-woodsmoke-500 text-woodsmoke-100 flex justify-center items-center">
                  <!-- <span class="iconify text-sm" data-icon="ant-design:info-outlined"></span> -->
                  <Icon name="ant-design:info-outlined" class="text-sm"></Icon>
                </button>

                <template #popper="{ hide }">
                  <div class="text-woodsmoke-50 p-4 sm:rounded-xl sm:max-w-sm sm:border sm:border-woodsmoke-500 border-t border-t-woodsmoke-100">
                    <div class="mb-4 text-sm font-light space-y-4">
                      <p>Min: {{ p?.contrib_min }} {{ p?.currency_symbol }}</p>
                      <p>Max: {{ p?.contrib_max }} {{ p?.currency_symbol }}</p>
                      <p>Guarantee Allocation : {{ p?.guarantee_allocation }} {{ p?.currency_symbol }}</p>
                      <p>Allocation Fee : {{ p?.allocation_fee }} {{ p?.currency_symbol }}</p>
                      <p>Refund : {{ p?.refund }} {{ p?.currency_symbol }}</p>
                    </div>

                    <button @click="hide()" v-if="isMobile" class="btn w-full bg-woodsmoke-800 text-turquoise-500 text-xs tracking-widest border border-woodsmoke-700">Close</button>
                  </div>
                </template>
              </VDropdown>

              <p class="font-bold text-base">
                &nbsp; {{ p?.pool_name }} &nbsp;
                <span class="font-light">( {{ p?.pool_desc }} )</span>
              </p>
              <!-- <div class="ml-4 font-light tracking-wider text-xs">Min: {{ p?.contrib_min }} {{ p?.currency_symbol }}&nbsp;&nbsp;Max: {{ p?.contrib_max }} {{ p?.currency_symbol }}</div> -->
            </div>
          </article>

          <ul v-if="p?.contrib_activity?.length > 0" class="">
            <li v-for="(act, index) in p?.contrib_activity" :key="act" class="">
              <article class="py-2">
                <span class="font-bold">#{{ index + 1 }}</span>
                - {{ act?.tokenAmountEtherNumber }} {{ p?.currency_symbol }}
                <a class="btn btn-link btn-sm text-turquoise-500 capitalize font-semibold" :href="getExplorer(p?.chain, act?.transactionHash)" target="_blank">View in Explorer</a>
                <span v-if="p?.contrib_activity?.length == 0" class="font-bold">No Contribution Found.</span>
              </article>
            </li>
          </ul>

          <!-- <ul v-if="p?.contrib_activity.length < 1" class="">
            <li class="">
              <article class="py-2">
                <span class="font-light italic">No Contribution Found.</span>
              </article>
            </li>
          </ul> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
const prop = defineProps({
  pool: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});
const { pool, index } = toRefs(prop);

const showDetails = ref(false);

// const defaultCurrency = computed(() => {
//   for(let p of pool?.pools) {
//     console.log("p p p", p)
//     return p?.currency_symbol
//   }
//   return 'USD'
// })

import { useScreens } from "vue-screen-utils";

const { mapCurrent } = useScreens({
  xs: "0px",
  sm: "640px",
  md: "768px",
  lg: "1024px",
});

const isMobile = mapCurrent({
  xs: true,
  sm: false,
  md: false,
  lg: false,
});

const getExplorer = (chain, txn) => {
  if (!chain) chain = 56;
  if (chain == 56) return `https://bscscan.com/tx/${txn}`;
  if (chain == 97) return `https://testnet.bscscan.com/tx/${txn}`;
  if (chain == 42161) return `https://arbiscan.io/tx/${txn}`;
  if (chain == 421613) return `https://goerli.arbiscan.io/tx/${txn}`;
  if (chain == 1) return `https://etherscan.io/tx/${txn}`;
  if (chain == 5) return `https://goerli.etherscan.io/tx/${txn}`;
  if (chain == 8453) return `https://basescan.org/tx/${txn}`;
  if (chain == 8453) return `https://sepolia.basescan.org/tx/${txn}`;
  if (chain == 137) return `https://polygonscan.com/tx/${txn}`;
};
</script>

<style scoped>
ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
  position: relative;
}
li {
  list-style-type: none;
  border-left: 2px solid #373e4e;
  margin-left: 1em;
}
li article {
  padding-left: 1em;
  position: relative;
}
li article::before {
  content: "";
  position: absolute;
  top: 0;
  left: -2px;
  bottom: 50%;
  width: 0.75em;
  border: 2px solid #373e4e;
  border-top: 0 none transparent;
  border-right: 0 none transparent;
}
ul > li:last-child {
  border-left: 2px solid transparent;
}
</style>
